import { createSlice } from "@reduxjs/toolkit";
import { DropdownFilterOption } from "../../types/orders";

type State = {
  payload: DropdownFilterOption | null;
};

const slice = createSlice({
  name: "warehouseCategoryFilter",
  initialState: { payload: null } as State,
  reducers: {
    warehouseCategoryFilter: (state, { payload }: State) => {
      state.payload = payload;
    }
  }
});

export const { warehouseCategoryFilter } = slice.actions;
export default slice.reducer;
